import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImageProxyService{
  private proxyUrl = 'https://images.weserv.nl/?url=';

  constructor() { }

  getProxiedImageUrl(imageUrl: string): string {
    return `${this.proxyUrl}${encodeURIComponent(imageUrl)}`;
  }
}
